import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { GameToBrowserButton } from "@components/Game/Misc";
import { YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function UpcomingReleasesScreen() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:upcoming_releases"));
    if (!apiData) return null;

    return (
        <DefaultLayout>
            <ListingCard header={t("Ближайшие релизы")}>
                <Table hover responsive className="dmg-table">
                    <thead>
                        <tr>
                            <th>{t("Дата выхода игры")}</th>
                            <th>{t("Отображение")}</th>
                            <th>{t("Предполагаемая дата")}</th>
                            <th>{t("Название игры")}</th>
                            <th>{t("Компания")}</th>
                            <th>{t("Тип")}</th>
                            <th style={{ width: "1%" }}>{t("Возрастной рейтинг")}</th>
                            <th style={{ width: "1%" }}>{t("Взрослый контент")}</th>
                            <th style={{ width: "1%" }}>{t("Публикация страницы")}</th>
                            <th style={{ width: "1%" }}>{t("Демо")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiData?.object_list?.map((item, idx) => (
                            <tr key={item.id ?? idx}>
                                <td>{item.date_launch}</td>
                                <td>{item.date_release_estimated_variant}</td>
                                <td>{item.date_release_estimated}</td>
                                <td>
                                    <Link to={url_reverse("games:page", { game_id: item.id })}>{item.name}</Link>
                                    <GameToBrowserButton game={item} />
                                </td>
                                <td>
                                    <Link to={url_reverse("devs:edit", { dev_id: item.developer_id })}>
                                        {item.developer_name}
                                    </Link>
                                </td>
                                <td>{item.type}</td>
                                <td>{item.age_limit}</td>
                                <td>
                                    <YesNoColumn attr={item.erotica} />
                                </td>
                                <td>
                                    <YesNoColumn attr={item.gamepage_is_published} />
                                </td>
                                <td>
                                    <YesNoColumn attr={item.demo_is_published} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ListingCard>
        </DefaultLayout>
    );
}
